import { Box, ColorOptions, Icon, SpacerNew, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { campaignDetailKeys, Colors } from '../../util/util'
import { TextWithCopy } from './TextWithCopy'

const RenderItem = ({ title, subTitle, showCopyIcon = false }: any) => {
  if (!subTitle || isEmpty(subTitle)) {
    return null
  }
  return (
    <Box pt={8} pb={16} pr={16} w={300}>
      <Text
        title={campaignDetailKeys[title] ?? title}
        color={Colors.HELPER_TEXT as ColorOptions}
        fontSize={12}
        fontFamily={'jiotype-medium'}
      />
      <SpacerNew size={8} direction={'vertical'} />
      <TextWithCopy text={subTitle} showCopyIcon={showCopyIcon} />
    </Box>
  )
}
const getTitle: any = {
  details: 'Campaign Details',
  rewards: 'Rewards',
}

const getIcon: any = {
  details: 'INFO',
  rewards: 'GIFT_CARD',
}
export const BasicDetails = ({ data, type }: any) => {
  const keys = Object.keys(data)
  return (
    <>
      <Box flexDirection={'row'} align={'center'}>
        <Box h={32} w={32} borderRadius={16} borderWidth={1} borderColor={'BLUE'} align={'center'} justify={'center'}>
          <Box bg={'#E2F1F6' as ColorOptions} w={24} h={24} borderRadius={12} align={'center'} justify={'center'}>
            <Icon color={'BLUE'} size={16} id={getIcon[type]} />
          </Box>
        </Box>
        <SpacerNew direction="horizontal" size={10} />
        <Text title={getTitle[type]} fontSize={14} fontFamily={'jiotype-bold'} />
      </Box>
      <Box
        marginVertical={8}
        borderLeftWidth={type === 'rewards' ? 0 : 2}
        borderLeftColor={'BLUE'}
        ph={26}
        ml={15}
        flexDirection={'row'}
        flexWrap={'wrap'}>
        {keys.map((item) => (
          <RenderItem title={item} subTitle={data[item]} showCopyIcon={item === 'linkedCampaigns'} />
        ))}
      </Box>
    </>
  )
}
